import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class LUISNode extends BaseNode {
    constructor() {
        super();
        this.name = 'LUIS On/Off';
        this.id = 'node_luis';
        this.icon = 'FaBluetoothB';
        this.linkedFeature = 'luis';
        this.requirements = ['bluetooth'];

        this.inputs = [
            {
                name: 'Enable',
                portId: 'luis_enable',
                params: [
                    {
                        name: 'on_off',
                        dataType: TibboDataType.BOOLEAN,
                        default: '1',
                    },
                ],
            },
        ];
    }

    getSettingOptions(settingId: string): SettingOption[] | undefined {
        if (settingId === 'on_off') {
            return [
                {
                    value: '1',
                    name: 'On',
                },
                {
                    value: '0',
                    name: 'Off',
                },
            ];
        }
        return super.getSettingOptions(settingId);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;

        const doneLinks = project.getNodeLinks(this, 'done');
        const doneBlock = doneLinks.length > 0 ? `'****${doneLinks[0].getSourceId()}****'` : '';
        const links = project.getNodeLinks(this, 'luis_enable');
        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];
            const enableCode = `
    'enable the BLE interface and wait for it to become enabled
    '(blocking version)
    if bt.enabled=NO then
        bt.enable()
    end if
    dim bt_wait as dword=sys.timercountms + 4000
    while bt.enabled=NO AND sys.timercountms < bt_wait
    wend
    if bt.enabled=NO then
        sys.debugprint("Bluetooth failed to boot")
    else
        bt.advertise=YES 'allow the device to be discoverable
    end if`;
            const disableCode = `
    'disable the BLE interface and wait for it to become enabled
    '(blocking version)
    bt.disable()
    dim bt_wait as dword=sys.timercountms + 4000
    while bt.enabled=YES AND sys.timercountms < bt_wait
    wend
    if bt.enabled=YES then
        sys.debugprint("Bluetooth failed to disable")
    end if`;
            blocks.push({
                location: link.getSourceId(),
                id: link.getID(),
                blockType: BlockType.CODE,
                template: `
    ${project.getNodeParameter(link, 'on_off') === '1' ? enableCode : disableCode}
    ${doneBlock}`,
            });
        }

        return blocks;
    }
}
